import t, { useState as s } from "react";
import { useTranslation as E } from "react-i18next";
import { Modal as y } from "../../../common/components/Modal/Modal.js";
import { UrlsAPI as b } from "../../../../../js/urls/index.js";
import { TextInput as w } from "../../../common/components/forms/TextInput/TextInput.js";
import a from "./magicLinkDetection.module.scss.js";
import { useCodeRequest as h } from "../../hooks/useCodeRequest.js";
import { useAuth as v } from "../../hooks/useAuth.js";
function S({
  onMagicAuth: r
}) {
  const { t: o } = E(), {
    login: m,
    setToken: d,
    magicLinkPending: u,
    cancelMagicLink: g
  } = v(), { isLoading: i, mutateAsync: k } = h(), [f, C] = s(""), [l, c] = s(!1), p = async () => {
    const n = new URL(window.location.toString()).searchParams.get(
      "shared_secret"
    );
    if (n)
      try {
        const e = await k({
          code: f,
          sharedSecret: n
        });
        if (!(e != null && e.token)) {
          c(!0);
          return;
        }
        d(e == null ? void 0 : e.token), r == null || r(e == null ? void 0 : e.token), b.removeParamFromUrl("shared_secret");
      } catch {
        c(!0);
      }
  };
  return /* @__PURE__ */ t.createElement(
    y,
    {
      show: u,
      showCloseBtn: !1,
      design: {
        backgroundColor: "#FFF",
        textColor: "#000"
      },
      dismissOnEscape: !1,
      dismissOnBackdrop: !1,
      onClose: () => g(),
      title: o("magiclink.email.title") ?? ""
    },
    /* @__PURE__ */ t.createElement("div", { "data-testid": "magic-link-detection" }, /* @__PURE__ */ t.createElement(
      w,
      {
        label: o("magiclink.email.code.input"),
        placeholder: o("magiclink.email.code.input"),
        design: {
          textColor: "#000"
        },
        onChange: (n) => C(n.target.value.trim())
      }
    ), l && /* @__PURE__ */ t.createElement("div", { className: a.codeError }, /* @__PURE__ */ t.createElement("i", { className: "lni-warning" }), " ", o("magiclink.email.code.error"))),
    /* @__PURE__ */ t.createElement("div", null, l && /* @__PURE__ */ t.createElement(
      "button",
      {
        disabled: i,
        id: "try-again",
        style: {
          backgroundColor: "transparent",
          color: "#000"
        },
        className: a.link,
        type: "button",
        onClick: () => m()
      },
      o("magiclink.email.code.try.again") ?? ""
    )),
    /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(
      "button",
      {
        id: "send-code",
        disabled: i,
        style: {
          backgroundColor: "#000",
          color: "#fff"
        },
        className: a.magicButton,
        type: "button",
        onClick: () => p()
      },
      o("magiclink.email.code.continue") ?? ""
    ))
  );
}
export {
  S as MagicLinkDetection
};
//# sourceMappingURL=MagicLinkDetection.js.map
